<template>
  <el-autocomplete
    popper-class="td-autocomplete"
    v-model="values"
    style="width: 100%;"
    :clearable="true"
    :fetch-suggestions="querySearchAsync"
    placeholder='请输入内容'
    @select="handleSelect">
    <template slot-scope="{ item }">
      <span style="float: left"><i class="fa fa-gg-circle" :style="{'color':item.sourceType==='cus'?'#f78989':'#66b1ff','margin-right': '5px'}"></i>{{ item.logisticName }}</span>
    </template>
  </el-autocomplete>
</template>
<script>

import { getLogisticName } from '@/api/basic/logistic'
import { validatenull } from '@/tdcommon/validate'
export default {
  // 责任方 封装公用调用方法
  name: 'd2-responsible-party',
  data () {
    return {
      values: this.value,
      oldValue: '',
      restaurants: []
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    loadAll () {
    },
    querySearchAsync (queryString, cb) {
      var searchStr = validatenull(queryString) ? '' : queryString
      getLogisticName(searchStr, '').then(response => {
        if (response.code === 0) {
          this.restaurants = response.data
          this.oldValue = queryString
          cb(this.restaurants)
        } else {
          cb()
        }
      })
    },
    handleSelect (item) {
      this.values = item.logisticName
      this.$emit('change', item)
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val)
    },
    value: function (val, oldVal) {
      this.values = val
    }
  },
  mounted () {
    this.loadAll()
  }
}
</script>

<style lang="scss" scoped>
  .td-autocomplete {
    li {
      line-height: normal;
      padding: 7px;
      .name {
        font-size: 16px;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }
      .highlighted .addr {
        color: #ddd;
      }
    }
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-responsible-party/index.vue"
}
</vue-filename-injector>
